{
  "breadcrumbAriaLabel": "Tautan navigasi",
  "homeAriaLabel": "Beranda",
  "mainNavAriaLabel": "Navigasi utama",
  "closeSidebarAriaLabel": "Tutup bilah samping",
  "collapse": "Ciutkan",
  "help": "Bantuan",
  "settings": "Pengaturan",
  "myProfile": "Profil Saya",
  "groups": {
    "clinical": "Klinis",
    "worklists": "Daftar Kerja",
    "documentation": "Dokumentasi Klinis",
    "orders": "Perintah Medis",
    "medications": "Obat-obatan",
    "scheduling": "Penjadwalan",
    "billing": "Penagihan",
    "analytics": "Analitik",
    "organization": "Organisasi",
    "security": "Keamanan",
    "accessReviews": "Access Reviews",
    "integrations": "Integrasi",
    "system": "Sistem",
    "licensing": "Lisensi"
  },
  "dashboard": "Dasbor",
  "patients": "Pasien",
  "patientSearch": "Cari Pasien",
  "myPatients": "Pasien Saya",
  "censusBedBoard": "Pasien Rawat Inap / Papan Tempat Tidur",
  "providerDirectory": "Direktori Dokter",
  "providerCoverage": "Jadwal Jaga Dokter",
  "patientMerge": "Gabungkan Data Pasien",
  "inbox": "Kotak masuk",
  "pendingResults": "Hasil Menunggu",
  "criticalResults": "Hasil Kritis",
  "unsignedNotes": "Catatan Belum Ditandatangani",
  "cosignQueue": "Antrean Tanda Tangan Bersama",
  "noteTemplates": "Templat Catatan",
  "smartPhrases": "Frasa Cerdas",
  "orderCatalog": "Katalog Perintah",
  "orderSets": "Paket Perintah",
  "encounters": "Kunjungan Klinis",
  "orders": "Perintah Medis",
  "results": "Hasil",
  "medications": "Obat-obatan",
  "notes": "Catatan Klinis",
  "medicationWorklist": "Medication Worklist",
  "formulary": "Formularium",
  "pharmacistQueue": "Antrean Apoteker",
  "appointments": "Janji Temu",
  "scheduleManagement": "Manajemen Jadwal",
  "waitlist": "Daftar Tunggu",
  "charges": "Biaya",
  "claims": "Klaim",
  "payments": "Pembayaran",
  "accounts": "Akun",
  "statements": "Pernyataan Tagihan",
  "denials": "Penolakan",
  "analyticsDashboard": "Dasbor",
  "reports": "Laporan",
  "qualityMeasures": "Indikator Mutu",
  "healthSystems": "Jaringan Kesehatan",
  "facilities": "Fasilitas",
  "locations": "Lokasi",
  "clinicalTaxonomy": "Taksonomi Klinis",
  "serviceLocation": "Layanan ↔ Lokasi",
  "providers": "Tenaga Medis",
  "users": "Pengguna",
  "roles": "Peran",
  "accessMatrix": "Matriks Akses",
  "integrations": "Integrasi",
  "thirdPartyApps": "Aplikasi Pihak Ketiga",
  "audit": "Audit",
  "system": "Sistem",
  "cdsRules": "Aturan CDS",
  "escalationRules": "Escalation Rules",
  "segments": {
    "search": "Cari",
    "register": "Daftar",
    "demographics": "Demografi",
    "census": "Rawat Inap",
    "discharge": "Pulang",
    "catalog": "Katalog",
    "sets": "Paket Perintah",
    "pending": "Menunggu",
    "critical": "Kritis",
    "reconciliation": "Rekonsiliasi Obat",
    "worklist": "Daftar Kerja",
    "templates": "Templat",
    "smartPhrases": "Frasa Cerdas",
    "schedule": "Manajemen Jadwal",
    "quality": "Indikator Mutu",
    "administration": "Administrasi",
    "auditLog": "Log Audit",
    "allergies": "Alergi",
    "problems": "Daftar Masalah",
    "immunizations": "Imunisasi",
    "insurance": "Asuransi"
  },
  "handoffs": "Serah Terima",
  "duplicateReview": "Tinjauan Duplikat",
  "sso": "SSO & Directories",
  "userGroups": "User Groups",
  "fileKey": "File key",
  "ordersWorklist": "Daftar Kerja Order"
}
